var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H35C37.7614 0 40 2.23858 40 5V35C40 37.7614 37.7614 40 35 40H5C2.23858 40 0 37.7614 0 35V5Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7242 13.9667C14.7465 13.7774 14.8127 13.5959 14.9176 13.4367C15.0224 13.2775 15.163 13.1451 15.3281 13.0498C15.4932 12.9545 15.6783 12.8992 15.8686 12.8881C16.0589 12.8769 16.2491 12.9104 16.4242 12.9858C17.3092 13.3642 19.2925 14.2633 21.8092 15.7158C24.3267 17.1692 26.0975 18.4383 26.8667 19.0142C27.5233 19.5067 27.525 20.4833 26.8675 20.9775C26.1058 21.55 24.3567 22.8025 21.8092 24.2742C19.2592 25.7458 17.2992 26.6342 16.4225 27.0075C15.6675 27.33 14.8225 26.8408 14.7242 26.0267C14.6092 25.075 14.3942 22.9142 14.3942 19.9958C14.3942 17.0792 14.6083 14.9192 14.7242 13.9667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayers);
export default __webpack_public_path__ + "static/media/players.c87504774faf9eb4363935b79ecfe783.svg";
export { ForwardRef as ReactComponent };